var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-print-none float-lg-right mb-3" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.close()
            }
          }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("Btn_CloseInstructions")) + "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.print()
            }
          }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("Btn_PrintInstructions")) + "\n    "
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _vm.showInstructions("yearlyreport")
            ? _c("organisation-yearly-report-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("aidapplication")
            ? _c("aid-application-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("aidtargetyearlyreport")
            ? _c("aid-target-yearly-report-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("accountnumberrequest")
            ? _c("account-number-request-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("aupreport")
            ? _c("aup-report-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("expandedsbe")
            ? _c("expanded-strategy-and-budgetary-estimate-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("investmentreport")
            ? _c("investment-report-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("paymentplan")
            ? _c("payment-plan-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("summaryreport")
            ? _c("summary-report-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("continuousreport")
            ? _c("continuous-report-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("paymentrequester")
            ? _c("payment-request-expense-report-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("deadlinechange")
            ? _c("deadline-change-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("purposechange")
            ? _c("purpose-change-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("targetchange")
            ? _c("target-change-instructions")
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstructions("continuousreportsummary")
            ? _c("continuous-report-summary-instructions")
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }